export class ErrorMessages {
  static messages(label = "This field", maxFileSize?: number) : { type: string; message: string }[] {
    return [
      {
        type: "required",
        message: `${label} is required`,
      },
      {
        type: "unique",
        message: `${label} must be unique`,
      },
      {
        type: "notBlank",
        message: `${label} cannot be blank`,
      },
      {
        type: "email",
        message: `${label} is invalid`,
      },
      {
        type: "noSpace",
        message: `Blank space not allowed`,
      },
      {
        type: "minlength",
        message: `Too short`,
      },
      {
        type: "maxlength",
        message: `Too long`,
      },
      {
        type: "invalidPhoneNumber",
        message: `${label} is not valid`,
      },
      {
        type: "validatePhoneNumber",
        message: `${label} is invalid`,
      },
      // Password validation errors
      {
        type: "tooShort",
        message: `${label} must be at least 8 characters long`,
      },
      {
        type: "missingUppercase",
        message: `${label} must include an uppercase letter`,
      },
      {
        type: "missingNumber",
        message: `${label} must include a number`,
      },
      {
        type: "missingSpecialCharacter",
        message: `${label} must include a special character`,
      },
      {
        type: "passwordMismatch",
        message: `Passwords must match`,
      },
      {
        type: "invalidBusinessNumber",
        message: `Please enter a valid CAC business number`,
      }, {
        type: "invalidASIN",
        message: `ASIN is invalid`,
      },
      {
        type: 'emailAlreadyInUse',
        message: 'This email is already in use'
      },
      {
        type: 'invoiceAlreadyPaid',
        message: 'This invoice is already paid for'
      },
      {
        type: 'emailAlreadyInUse',
        message: 'This email is already in use'
      },
      {
        type: 'invalidContact',
        message: 'Email or phone number is invalid'
      },

      {
        type: 'invalid',
        message: `${label} is invalid`
      }
      ,
      {
        type: 'invoiceAlreadyPaid',
        message: `Invoice has already been paid for`
      },
      {
        type: 'maxFileSize',
        message: `Uploaded file is too large (Max: ${maxFileSize}MB)`
      },
      {
        type: 'maxDateRange',
        message: `Date range must not exceed ${7} days`
      }
    ];
  }
}
